/*
 * @Description: 通知公告
 * @Author: fxg
 * @Date: 2020-06-29 11:18:28
 * @LastEditors: fxg
 * @LastEditTime: 2020-06-29 13:34:36
*/
import request from '@/utils/request'
export const Download = "/base/system/notice/export";
export function batchUpdateOrDelete(data) {
  return request({
    url: '/base/system/notice/batch_update_or_delete',
    method: 'post',
    data
  })
}
export function getDetail(id) {
  return request({
    url: '/base/system/notice/get_detail?id=' + id,
    method: 'get'
  })
}
export function publish(params) {
  return request({
    url: '/base/system/notice/publish',
    method: 'get',
    params,
  })
}
export function finalDoc(params) {
  return request({
    url: '/base/system/notice/final_doc',
    method: 'get',
    params,
  })
}
export function queryPage(data) {
  return request({
    url: '/base/system/notice/query_page',
    method: 'post',
    data
  })
}
export function indexQueryPage(data) {
  return request({
    url: '/base/system/notice/index/query_page',
    method: 'post',
    data
  })
}
export function saveOrUpdate(data) {
  return request({
    url: '/base/system/notice/save_or_update',
    method: 'post',
    data
  })
}
export function updateSortNum(data) {
  return request({
    url: '/base/system/notice/update_sort_num',
    method: 'post',
    data
  })
}
//更新已读状态
export function update_read_status(data) {
  return request({
    url: '/base/system/notice/update_read_status',
    method: 'post',
    data
  })
}
